<h1 class="font-bold md:font-normal text-black text-2xl md:text-1.5xl">
  <mat-icon *ngIf="icon" fontSet="fa" [fontIcon]="icon"></mat-icon>{{ title }}
</h1>
